import { ReactNode, useEffect, useMemo } from 'react';
import intl from 'i18n/intl';
import { filterOptionLowerCaseInclude } from 'pages/appSettings/allocateSettings/ViewerPage';
import { reservationModesSelector } from 'slices/reservationMode.slice';
import { useAppSelector } from 'slices/store';
import type { TReservationMode } from '@timeedit/types/lib/types';
import { Select, TEInput } from '@timeedit/ui-components';
import { fetchReservationModes } from '../../../../slices/reservationMode.slice';
import { useAppDispatch } from '../../../../slices/store';

const language = intl.messages as Record<string, string>;

type ReservationModeProps = {
  mode: number;
  setMode: (value: number) => void;
  help?: ReactNode;
};

const RESERVATION_MODE_ALL = 0;

export function ReservationMode({ mode, setMode, help }: ReservationModeProps) {
  const dispatch = useAppDispatch();
  const reservationModes: TReservationMode[] = useAppSelector(
    reservationModesSelector
  );

  useEffect(() => {
    dispatch(fetchReservationModes());
  }, [dispatch]);

  const modeOptions = useMemo(() => {
    const modes = reservationModes
      .map((mode) => ({
        value: mode.id,
        label: mode.name,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
    return [
      { label: language.reservationModeAll, value: RESERVATION_MODE_ALL },
    ].concat(modes);
  }, [mode, reservationModes]);

  return (
    <div className="row-box">
      <TEInput.LabelWrapper
        label={language.reservationMode}
        tooltip={`Recommended is ${language.reservationMode}: ${language.reservationModeAll}`}
      >
        <Select
          key={'modeDropdown'}
          value={mode ?? RESERVATION_MODE_ALL}
          style={{ minWidth: '30em', maxWidth: '50em' }}
          showSearch
          placeholder={language.reservationModeSelect}
          onChange={setMode}
          filterOption={filterOptionLowerCaseInclude}
          options={modeOptions}
          popupMatchSelectWidth={false}
        />
      </TEInput.LabelWrapper>
      {help}
    </div>
  );
}
